import React from 'react'

interface SecuritySettingsProps {
  [key: string]: any
}

export const SecuritySettings: React.FC<SecuritySettingsProps> = (props) => {
  return (
    <div className="p-4 bg-gray-800 rounded-lg">
      <p className="text-gray-400">SecuritySettings Component - Coming Soon</p>
    </div>
  )
}
